import React from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectUsedTheme } from "_redux/slices/timeline/theme";
import { Spacing } from "_styles";

const EMPLOYEE_STATUS_OPTIONS = ["all", "online", "offline", "busy", "available", "onBreak"];

const EmployeeStatusFilter = ({ value = "all", onChange }) => {
  const usedTheme = useSelector(selectUsedTheme);

  const renderLabel = (status) =>
    status === "onBreak"
      ? "On Break"
      : `${status.charAt(0).toUpperCase()}${status.slice(1)}`;

  return (
    <Dropdown onSelect={(next) => onChange?.(next ?? "all")} data-tippy-content="Filter by Employee Status">
      <Dropdown.Toggle
        variant={usedTheme.BUTTON_VARIANT}
        id="employee-status-dropdown"
        style={{
          backgroundColor: usedTheme.BACKGROUND_COLOR,
          color: "gray",
          border: "1px solid",
          borderColor: usedTheme.BORDER_COLOR,
          width: "100%",
          height: Spacing.SCALE_38,
          textAlign: "left",
          padding: "8px",
          marginLeft: Spacing.SCALE_2,
          marginTop: Spacing.SCALE_4,
          marginBottom: Spacing.SCALE_4,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {renderLabel(value)}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR }}>
        {EMPLOYEE_STATUS_OPTIONS.map((status) => (
          <Dropdown.Item
            key={status}
            style={{ color: usedTheme.TEXT_COLOR }}
            eventKey={status}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = usedTheme.BORDER_COLOR;
              e.target.style.color = usedTheme.TEXT_COLOR;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = usedTheme.TEXT_COLOR;
            }}
          >
            {renderLabel(status)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default EmployeeStatusFilter;

